import styled from 'styled-components';

export default styled.div`
    .root {
        margin-right: 3rem;
        margin-left: 3rem;
        background-color: unset;
        box-shadow: unset;

        h3 {
            margin-bottom: 1rem;
        }

        div > span {
            display: inline-block;
            width: 5rem;
        }
    }

    .noMargin {
        flex-basis: 100%;
        margin-right: 0;
        margin-left: 0;
    }
`;
